// extracted by css-extract-rspack-plugin
export default {"table":"SinglePriceTable_table__a1jJr","row":"SinglePriceTable_row__7SOSL"};